/* eslint-disable @typescript-eslint/no-unused-vars */
import { http } from '@/lib/ats-https';
import { convertToFormData } from '@/lib/util';
// import { http as oldHttp } from '@/lib/http';

// main api calls to get the overall data
const getInterviewPlan = async ({ stageId, stageActivityId, contactId }) => {
  let url = `ats_interviews/new?ats_job_stage_id=${stageId}`;

  if (stageActivityId) {
    url += `&ats_job_stage_action_id=${stageActivityId}`;
  }

  if (contactId) {
    url += `&contact_id=${encodeURIComponent(contactId)}`;
  }
  const { data } = await http.get(url);
  return data;
};

// getInterviewDetails will fetch the  interview edit details
const getInterviewDetails = async (interviewId) => {
  const { data } = await http.get(`ats_interviews/${interviewId}`);
  return data;
};

const getCalendarInviteTemplates = async ({
  channel = null,
  category = null,
}) => {
  let apiURL =
    'ats_comm_templates?filter_by[channel]=calendar_invite&items=200';
  if (channel) apiURL += `&filter_by[category][]=${channel}`;
  if (category) apiURL += `&filter_by[category][]=${category}`;
  const { data } = await http.get(apiURL);
  return data;
};

const getDefaultScorecard = async ({ payload }) => {
  const response = await http.get('/ats_scorecards/default_template', payload);
  if (response?.['errors']?.length) {
    return { error: response?.['errors'] };
  }
  return response?.['data'];
};

const createInterview = async (payload) => {
  const response = await http.post('/ats_interviews', payload);
  if (response?.['errors']?.length) {
    return { error: response?.['errors'] };
  }
  return response?.['data'];
};

const updateInterview = async (payload, interviewId) => {
  const response = await http.put(`/ats_interviews/${interviewId}`, payload);
  if (response?.['errors']?.length) {
    return { error: response?.['errors'] };
  }
  return response?.['data'];
};

const createSelfSchedule = async (payload) => {
  const response = await http.post(
    `/ats_schedules`,
    convertToFormData(payload)
  );
  if (response?.['errors']?.length) {
    return { error: response?.['errors'] };
  }
  return response?.['data'];
};

const getSelfScheduleDetails = async (scheduleId) => {
  const response = await http.get(`/ats_schedules/${scheduleId}`);
  if (response?.['errors']?.length) {
    return { error: response?.['errors'] };
  }
  return response?.['data'];
};

const updateSelfSchedule = async (payload, scheduleId) => {
  const response = await http.put(
    `/ats_schedules/${scheduleId}`,
    convertToFormData(payload)
  );
  if (response?.['errors']?.length) {
    return { error: response?.['errors'] };
  }
  return response?.['data'];
};

const createBulkSelfSchedule = async (payload) => {
  delete payload.candidate_id;
  delete payload.contact_id;
  const response = await http.post(
    '/ats_schedules/bulk',
    convertToFormData(payload)
  );
  if (response?.['errors']?.length) {
    return { error: response?.['errors'] };
  }
  return response?.['data'];
};

const getStageActionDetails = async (payload) => {
  const {
    selectedApplicationIds,
    unSelectedApplicationIds,
    jobStageId,
    jobStatus,
  } = payload;
  const { data } = await http.get(`/ats_applications/bulk/interview_status`, {
    params: {
      ats_application_ids: selectedApplicationIds,
      ats_job_stage_id: jobStageId,
      bulk_selected_ats_job_stage_ids: unSelectedApplicationIds && [jobStageId],
      bulk_selected_application_statuses: unSelectedApplicationIds && [
        jobStatus,
      ],
      bulk_exempted_application_ids: unSelectedApplicationIds,
    },
  });
  return data;
};

const getInterviewPools = async () => {
  // Get interview pools used for schedule all feature
  const { data } = await http.get('/user_groups?type=ats_interviewer_pool');
  return data;
};

export const ScheduleAPI = {
  getInterviewPlan,
  getCalendarInviteTemplates,
  getDefaultScorecard,
  getInterviewDetails,
  createInterview,
  updateInterview,
  createSelfSchedule,
  getSelfScheduleDetails,
  updateSelfSchedule,
  createBulkSelfSchedule,
  getStageActionDetails,
  getInterviewPools,
};
